import { type ActionResponse, type Action } from '~/domains/promotion/types';
import { productSerializer } from '~/domains/product';
import { dateSerializer } from '~/domains/core';

export default function promotionSeializer(data: ActionResponse): Action {
  return {
    id: data.id,
    name: data.name,
    type: data.display_type,
    dateFrom: dateSerializer(data.date_from),
    dateTill: dateSerializer(data.date_till),
    htmlPreview: data.html_preview ?? '',
    hoverText: data.hover_text,
    htmlBody: data.html_body,
    product: productSerializer(data.products?.[0]),
    imageUrl: data.image_url ?? '',
    url: data?.url ?? null,
    target: data?.target ?? '_blank',
  };
}
